import React from "react";
import { NavLink } from "react-router-dom";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import "./Sidebar.css"; // Custom CSS for Sidebar
import logo from "../assets/logo.png"; // Logo image


const Sidebar = () => {
  return (
    <div className="sidebar">
      <img src={logo} alt="Teqluc Logo" className="sidebar-logo"/>
      <nav className="menu">
        <NavLink to="/" className="menu-item" activeClassName="active">
          <i className="fas fa-tablet-alt"></i>{" "}
          <span className="menu-text">Inventory</span>
        </NavLink>
        {/* {auth?.currentUser?.email.toString().toLowerCase() ===
        "kdarji@teqluc.in" ? (
          <NavLink to="/billing" className="menu-item" activeClassName="active">
            <i className="fas fa-cogs"></i>{" "}
            <span className="menu-text">Billing Data</span>
          </NavLink>
        ) : null} */}
      </nav>
      <button
        className="btn btn-danger signout-btn"
        onClick={() => signOut(auth)}
      >
        <i className="fas fa-sign-out-alt"></i> Sign Out
      </button>
    </div>
  );
};

export default Sidebar;
